import React, { useEffect, useMemo, useState } from "react";
import { FaSearch, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from "../../../js/api.js";
import BotaoBusca from "../../components/BotaoBusca.js";
import Loader from "../../components/Loader/index.js";

const etapasExemplo = [
  { id: 1, nome: "Cadastro inicial" },
  { id: 2, nome: "Inclusão do calendário" },
  { id: 3, nome: "Validação do preenchimento" },
  { id: 4, nome: "Confecção do contrato" },
  { id: 5, nome: "Aguardando assinatura" },
  { id: 6, nome: "Contrato finalizado" },
];

// Mapeia o status retornado pelo backend para a etapa equivalente no stepper
const STATUS_PARA_ETAPA = {
  AGUARDANDO_ESTUDANTE: 1,
  AGUARDANDO_VALIDACAO_CIEEMG: 3,
  EM_VALIDACAO: 3,
  AGUARDANDO_CONFECCAO: 4,
  CONTRATO_CONFECCIONADO: 4,
  AGUARDANDO_ASSINATURAS: 5,
  DISPONIBILIZADO_PARA_ASSINATURA: 5,
  FINALIZADO: 6,
  REPROVADO_EMPRESA: 2,
  REPROVADO_ESTUDANTE: 2,
  REPROVADO_DEFINITIVO: 2,
  PENDENTE: 1,
  APROVADO: 6,
  RECUSADO: 2,
};

const STATUS_LABELS = {
  AGUARDANDO_ESTUDANTE: "Aguardando preenchimento do Estudante",
  AGUARDANDO_VALIDACAO_CIEEMG: "Aguardando validação do CIEEMG",
  EM_VALIDACAO: "Em validação pelo CIEEMG",
  AGUARDANDO_CONFECCAO: "Aguardando confecção do contrato",
  CONTRATO_CONFECCIONADO: "Contrato confeccionado",
  AGUARDANDO_ASSINATURAS: "Aguardando assinaturas",
  DISPONIBILIZADO_PARA_ASSINATURA: "Disponibilizado para assinatura",
  FINALIZADO: "Finalizado",
  REPROVADO_EMPRESA: "Reprovado — voltar p/ Empresa",
  REPROVADO_ESTUDANTE: "Reprovado — voltar p/ Estudante",
  REPROVADO_DEFINITIVO: "Reprovado definitivamente",
  PENDENTE: "Pendente",
  APROVADO: "Aprovado",
  RECUSADO: "Recusado",
};

const STATUS_CORES = {
  PENDENTE: "#3b82f6",
  AGUARDANDO_ESTUDANTE: "#3b82f6",
  AGUARDANDO_VALIDACAO_CIEEMG: "#3b82f6",
  EM_VALIDACAO: "#1e40af",
  AGUARDANDO_CONFECCAO: "#3b82f6",
  CONTRATO_CONFECCIONADO: "#1e40af",
  AGUARDANDO_ASSINATURAS: "#3b82f6",
  DISPONIBILIZADO_PARA_ASSINATURA: "#1e40af",
  FINALIZADO: "#134b8b",
  APROVADO: "#1e3a8a",
  REPROVADO_EMPRESA: "#ef4444",
  REPROVADO_ESTUDANTE: "#ef4444",
  REPROVADO_DEFINITIVO: "#dc2626",
  RECUSADO: "#dc2626",
};

const formatarCnpjCpf = (valor) => {
  if (!valor) return "";
  const nums = String(valor).replace(/\D/g, "").slice(0, 14);
  if (nums.length === 0) return "";
  if (nums.length <= 11) {
    return nums
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  return nums
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
};

const Stepper = ({ etapaAtual = 1, etapas = etapasExemplo }) => {
  return (
    <div className="stepper-wrapper">
      <div className="stepper-linha-bg" />
      <div
        className="stepper-linha-progresso"
        style={{
          width: `${
            etapas.length > 1
              ? ((etapaAtual - 1) / (etapas.length - 1)) * 100
              : 0
          }%`,
        }}
      />
      <div className="stepper-bolinhas">
        {etapas.map((etapa, index) => {
          const numero = index + 1;
          const status =
            numero < etapaAtual
              ? "concluida"
              : numero === etapaAtual
                ? "andamento"
                : "pendente";

          return (
            <div className="stepper-etapa" key={etapa.id}>
              <div className={`stepper-bolinha stepper-bolinha-${status}`}>
                {status === "concluida" ? "✓" : numero}
              </div>
              <span className={`stepper-label stepper-label-${status}`}>
                {etapa.nome}
              </span>
            </div>
          );
        })}
      </div>
      <p className="stepper-status-texto">
        Etapa {etapaAtual} de {etapas.length} —{" "}
        <strong>{etapas[etapaAtual - 1]?.nome}</strong>
      </p>
    </div>
  );
};

const Acompanhamento = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [busca, setBusca] = useState("");
  const [buscaDigitada, setBuscaDigitada] = useState("");
  const [itens, setItens] = useState([]);
  const [itemSelecionado, setItemSelecionado] = useState(null);
  const [error, setError] = useState("");
  const [buscaHabilitada, setBuscaHabilitada] = useState(false);

  const executarBusca = () => {
    const termo = (buscaDigitada || "").trim();
    if (!termo) return; 
    setBuscaHabilitada(true);
    setBusca(termo);
  };

  useEffect(() => {
    if (!buscaHabilitada) return;

    let cancelado = false;

    (async () => {
      try {
        setLoading(true);
        setError("");

        const token = localStorage.getItem("token");
        const termo = (busca || "").trim();

        let empresaId = null;
        try {
          if (token) {
            const decoded = jwtDecode(token);
            empresaId =
              decoded?.empresa_id ||
              decoded?.empresaId ||
              decoded?.id_empresa ||
              null;
          }
        } catch (e) {
          // silencioso: token inválido segue com fallback
        }
        if (!empresaId) empresaId = localStorage.getItem("empresa_id");

        const params = {};
        if (empresaId) params.empresa_id = empresaId;
        if (termo) params.busca = termo;

        const response = await axios.get(
          `${API_BASE_URL}/tca-empregador`,
          {
            params,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (cancelado) return;

        const dados = Array.isArray(response.data)
          ? response.data
          : response.data?.itens || response.data?.data || [];

        setItens(dados);

        setItemSelecionado((atual) => {
          if (!dados.length) return null;
          if (atual && dados.some((d) => (d.id ?? d.tcaId) === (atual.id ?? atual.tcaId))) {
            return atual;
          }
          return dados[0];
        });
      } catch (err) {
        if (cancelado) return;
        const apiErrors =
          err.response?.data?.errors ||
          err.response?.data?.message ||
          "Erro ao carregar os acompanhamentos.";
        setError(
          Array.isArray(apiErrors) ? apiErrors.join(" | ") : apiErrors
        );
        setItens([]);
      } finally {
        if (!cancelado) setLoading(false);
      }
    })();

    return () => {
      cancelado = true;
    };
  }, [busca, buscaHabilitada]);

  const etapaAtual = useMemo(() => {
    const status = itemSelecionado?.status;
    if (!status) return 1;
    return STATUS_PARA_ETAPA[status.toUpperCase()] ?? 1;
  }, [itemSelecionado]);

  return (
    <div className="acompanhamento-container">
      <header className="acompanhamento-header">
        <div className="acompanhamento-header-titulo">
          <h1>Acompanhamento – CIEEMG</h1>
          <p>Acompanhe o status atual e as próximas etapas do processo.</p>
        </div>
        <button
          className="acompanhamento-btn-voltar"
          onClick={() => navigate("/dashboard")}
        >
          <FaArrowLeft /> Voltar
        </button>
      </header>

      <div className="acompanhamento-filtros">
        <div className="acompanhamento-input-wrapper">
          <FaSearch className="acompanhamento-input-icone" size={14} />
          <input
            type="text"
            placeholder="Buscar por CNPJ, Razão social, Nome do Estudante, CPF, Número do convênio, Código da empresa"
            value={buscaDigitada}
            onChange={(e) => setBuscaDigitada(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && executarBusca()}
            className="acompanhamento-input-busca"
          />
        </div>
        <BotaoBusca onClick={executarBusca} />
      </div>

      <section className="acompanhamento-stepper-card">
        <div className="identificacao-bar">
          <div className="identificacao-item">
            <span className="identificacao-label">CNPJ:</span>
            <span className="identificacao-valor">
              {itemSelecionado
                ? formatarCnpjCpf(
                    itemSelecionado.cnpj ||
                      itemSelecionado.cnpj_ou_cpf ||
                      itemSelecionado.cnpj_empresa ||
                      ""
                  )
                : "—"}
            </span>
          </div>
          <div className="identificacao-item">
            <span className="identificacao-label">Aprendiz:</span>
            <span className="identificacao-valor">
              {itemSelecionado
                ? itemSelecionado.nome_completo ||
                  itemSelecionado.nome ||
                  itemSelecionado.nome_estudante ||
                  "—"
                : "Selecione um registro abaixo"}
            </span>
          </div>
          {itemSelecionado?.status && (
            <div className="identificacao-item">
              <span
                className="status-badge"
                style={{
                  backgroundColor:
                    (STATUS_CORES[itemSelecionado.status.toUpperCase()] || "#94a3b8") + "22",
                  color:
                    STATUS_CORES[itemSelecionado.status.toUpperCase()] || "#94a3b8",
                }}
              >
                {STATUS_LABELS[itemSelecionado.status.toUpperCase()] ||
                  itemSelecionado.status}
              </span>
            </div>
          )}
        </div>

        <Stepper etapaAtual={etapaAtual} etapas={etapasExemplo} />
      </section>

      {error && (
        <p className="acompanhamento-vazio" style={{ color: "#dc2626" }}>
          {error}
        </p>
      )}

      {loading && <Loader message="Buscando autorizações..." />}

      {!loading && itens.length === 0 && (
        <p className="acompanhamento-vazio">
          {busca.trim()
            ? "Nenhum registro encontrado para o filtro informado."
            : "Nenhum registro encontrado."}
        </p>
      )}

      {!loading && itens.length > 0 && (
        <div className="acompanhamento-lista">
          {itens.map((item) => {
            const id = item.id ?? item.tcaId;
            const nome =
              item.nome_completo ||
              item.nome ||
              item.nome_estudante ||
              item.razao_social ||
              `Registro #${id}`;
            const statusKey = (item.status || "").toUpperCase();
            const cor = STATUS_CORES[statusKey] || "#fff";
            const isSelecionado = itemSelecionado?.id === id;

            return (
              <div
                className="acompanhamento-card"
                key={id}
                onClick={() => setItemSelecionado(item)}
                style={
                  isSelecionado
                    ? { borderColor: "#134b8b", borderWidth: 2 }
                    : undefined
                }
              >
                <div className="acompanhamento-card-info">
                  <h3>{nome}</h3>
                  {item.cnpj || item.cnpj_ou_cpf ? (
                    <p
                      style={{
                        margin: "0.25rem 0 0",
                        fontSize: 12,
                        color: "#64748b",
                      }}
                    >
                      CNPJ/CPF:{" "}
                      {formatarCnpjCpf(item.cnpj || item.cnpj_ou_cpf)}
                    </p>
                  ) : null}
                </div>
                <span
                  className="status-badge"
                  style={{
                    backgroundColor: cor + "22",
                    color: cor,
                  }}
                >
                  {STATUS_LABELS[statusKey] || item.status || "—"}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Acompanhamento;
